export default "/images/ea7aa14615d24eee2dabb98e97a8bfcb.avif";